import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
import * as BullCache from "../util/BullCache";

const apiUrl = process.env.REACT_APP_API_URL;


    var user = BullCache.getFromCache("user");


async function getQuantitySettings(payload) {
    const result = await axios.post(apiUrl + "/admin/get/quantitysetting",payload,{
  headers: jsonHeader}
    );
    return result.data || [];
}

async function addQuantitySettings(payload) {
    const result = await axios.post(apiUrl + "/admin/add/quantitysetting",payload,{
  headers: jsonHeader}
    );
    return result.data || [];
}

async function copyQuantitySettings(payload) {
  const result = await axios.post(apiUrl + "/admin/copy/quantitysetting",payload,{
headers: jsonHeader}
  );
  return result.data || [];
}

async function deleteQuantitySettings(payload) {
    const result = await axios.post(apiUrl + "/admin/delete/quantitysetting",payload,{
  headers: jsonHeader}
    );
    return result.data || [];
}


export const QuantitySettingsService = {
    getQuantitySettings,
    addQuantitySettings,
    deleteQuantitySettings,
    copyQuantitySettings
}